module.exports = __webpack_public_path__ + "img/no-transactions.5509e6da.svg";